import React from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { css, cx } from '@emotion/css'
import { WithTooltip } from '../../design-system'
import { panelTitleCss } from '../../legacy-design-system/text'
import { theme } from '@contrast-security-inc/design-system-foundations'

const pendingStatusIndicatorCss = cx(
  panelTitleCss,
  css`
    align-self: center;
    margin-top: 2px;
    margin-left: 3px;
  `
)

const tooltipContentCss = css`
  width: 200px;
  /* To override legacy grid cell style */
  word-break: initial;
`

const tooltipTitleCss = css`
  padding-bottom: 8px;
`

const dateCss = css`
  color: ${theme.color.neutral50};
`

const dateFormat: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: '2-digit',
  hour: 'numeric',
  minute: 'numeric'
}

interface Props {
  readonly created: string
}

export function TooltipContent({ created }: Props) {
  return (
    <div className={tooltipContentCss}>
      <FormattedMessage id="title_pendingStatuses">
        {(tooltipMessage) => {
          return <div className={tooltipTitleCss}>{tooltipMessage}</div>
        }}
      </FormattedMessage>
      {/*@ts-ignore https://github.com/formatjs/formatjs/pull/3852*/}
      <FormattedDate value={created} {...dateFormat}>
        {(date) => {
          return <div className={dateCss}>{date}</div>
        }}
      </FormattedDate>
    </div>
  )
}

export function PendingStatusIndicator({ created }: Props) {
  return (
    <WithTooltip
      renderTooltipContent={() => {
        return <TooltipContent created={created} />
      }}
    >
      {() => (
        <FormattedMessage id="title_pending">
          {(titlePending) => (
            <span className={pendingStatusIndicatorCss}>{titlePending}</span>
          )}
        </FormattedMessage>
      )}
    </WithTooltip>
  )
}
